import React from 'react';
import CourseCard from './CourseCard';
import UnityCard from './UnityCard';
import CommentCard from './CommentCard';
import PhoneButton from './PhoneButton';
import './CourseSection.css';

function CourseSection({ title, description, type }) {
  // 模拟课程数据
  const featuredCourses = [
    {
      id: 1,
      title: '高性能实时系统架构与框架十讲',
      category: 'Unity/C#/架构/性能优化',
      instructor: '李教授',
      originalPrice: 512,
      price: 256,
      enrollCount: '178',
      rating: 4.8,
      image: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/course/2021/04-25/04241715967f523586.png'
    },
    {
      id: 2,
      title: 'C/C++底层高级编程',
      category: 'C/C++/底层',
      instructor: '王教授',
      originalPrice: null,
      price: 512,
      enrollCount: '105',
      rating: 4.7,
      image: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/course/2024/01-07/01124913360b394847.png'
    },
    {
      id: 3,
      title: 'Python数据科学与机器学习',
      category: 'Python/数据科学/AI',
      instructor: '张教授',
      originalPrice: 699,
      price: 399,
      enrollCount: '320',
      rating: 4.9,
      image: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/course/2021/03-26/20241715afb1069505.png'
    },
    {
      id: 4,
      title: 'Web全栈开发实战',
      category: 'JavaScript/React/Node.js',
      instructor: '刘讲师',
      originalPrice: 799,
      price: 499,
      enrollCount: '256',
      rating: 4.6,
      image: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/course/2021/02-25/015455f2c1f5446881.png'
    },
    {
      id: 5,
      title: '游戏美术设计精髓',
      category: '游戏设计/3D建模/艺术',
      instructor: '孙老师',
      originalPrice: 899,
      price: 599,
      enrollCount: '145',
      rating: 4.8,
      image: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/course/2022/05-06/23524197f19e422886.png'
    },
    {
      id: 6,
      title: '移动应用UI/UX设计',
      category: 'UI设计/用户体验',
      instructor: '赵设计师',
      originalPrice: null,
      price: 399,
      enrollCount: '220',
      rating: 4.7,
      image: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/course/2021/11-28/0531059749be176824.png'
    },
    {
      id: 7,
      title: '区块链技术与应用',
      category: '区块链/加密货币',
      instructor: '钱教授',
      originalPrice: 999,
      price: 699,
      enrollCount: '98',
      rating: 4.5,
      image: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/course/2023/07-17/084102e5823a076778.png'
    },
    {
      id: 8,
      title: '网络安全与渗透测试',
      category: '网络安全/黑客防御',
      instructor: '周安全专家',
      originalPrice: 899,
      price: 599,
      enrollCount: '132',
      rating: 4.9,
      image: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/course/2021/04-08/032618a22341624984.png'
    }
  ];

  const unityCourses = [
    {
      id: 1,
      title: '《Unity永久班》',
      description: 'Unity游戏开发完整教程',
      students: 865,
      rating: 4.9,
      originalPrice: 4512,
      price: 1999,
      enrollCount: '606',
      image: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/course/2021/04-08/032618a22341624984.png'
    },
    {
      id: 2,
      title: '《Unity一年班》',
      description: 'Unity游戏一年会员课程',
      students: 665,
      rating: 4.8,
      originalPrice: null,
      price: 512,
      enrollCount: '1066',
      image: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/course/2021/04-25/04241715967f523586.png'
    },
    {
      id: 3,
      title: '《Unity 3D游戏开发精通》',
      description: '从零开始学习Unity 3D游戏制作',
      students: 782,
      rating: 4.7,
      originalPrice: 3999,
      price: 1799,
      enrollCount: '523',
      image: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/course/2023/07-17/084102e5823a076778.png'
    },
    {
      id: 4,
      title: '《Unity VR开发入门到精通》',
      description: '虚拟现实应用与游戏开发',
      students: 456,
      rating: 4.6,
      originalPrice: 2899,
      price: 1299,
      enrollCount: '328',
      image: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/course/2021/03-26/20241715afb1069505.png'
    },
    {
      id: 5,
      title: '《Unity AI编程基础》',
      description: '游戏人工智能与行为树设计',
      students: 534,
      rating: 4.9,
      originalPrice: 1999,
      price: 999,
      enrollCount: '412',
      image: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/course/2024/01-07/01124913360b394847.png'
    },
    {
      id: 6,
      title: '《Unity移动游戏开发》',
      description: 'iOS和Android平台游戏制作',
      students: 612,
      rating: 4.7,
      originalPrice: null,
      price: 899,
      enrollCount: '487',
      image: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/course/2021/11-28/0531059749be176824.png'
    },
    {
      id: 7,
      title: '《Unity着色器编程》',
      description: '高级视觉效果与图形渲染',
      students: 398,
      rating: 4.8,
      originalPrice: 2499,
      price: 1399,
      enrollCount: '276',
      image: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/course/2022/05-06/23524197f19e422886.png'
    },
    {
      id: 8,
      title: '《Unity多人在线游戏开发》',
      description: '网络游戏架构与实现',
      students: 521,
      rating: 4.9,
      originalPrice: 3699,
      price: 1899,
      enrollCount: '345',
      image: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/course/2021/02-25/015455f2c1f5446881.png'
    }
  ];

  const comments = [
    {
      id: 1,
      username: 'Frank1990',
      avatar: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/course/2024/03-03/2304160d2470297968.png',
      content: '这几天课程学习，感觉比很多1999的，买在是赚了个TM的了',
      rating: 5,
      date: '01-15',
      course: 'Unity系列'
    },
    {
      id: 2,
      username: 'Susan1990',
      avatar: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/course/2024/03-03/2304160d2470297968.png',
      content: '教学太详细了，跟着了解到很多技巧，建议！！！',
      rating: 5,
      date: '06-15',
      course: 'Unity系列'
    },
    {
      id: 3,
      username: 'CodeMaster',
      avatar: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/course/2024/03-03/2304160d2470297968.png',
      content: '讲师的讲解非常清晰，特别是在介绍复杂算法的时候，通俗易懂，没有晦涩难懂的感觉',
      rating: 5,
      date: '03-22',
      course: 'Python数据科学'
    },
    {
      id: 4,
      username: 'GameDev2022',
      avatar: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/course/2024/03-03/2304160d2470297968.png',
      content: '课程内容很丰富，但是有些章节讲得太快了，希望能放慢节奏多讲解一些细节',
      rating: 4,
      date: '05-16',
      course: 'Unity VR开发'
    },
    {
      id: 5,
      username: 'FrontEndLover',
      avatar: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/course/2024/03-03/2304160d2470297968.png',
      content: '课程质量超出预期！老师的React讲解让我对组件化思想有了更深入的理解，强烈推荐！',
      rating: 5,
      date: '04-30',
      course: 'Web全栈开发'
    },
    {
      id: 6,
      username: 'AIResearcher',
      avatar: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/course/2024/03-03/2304160d2470297968.png',
      content: '机器学习部分的实战案例很有实用价值，我已经把学到的技术应用到工作中了',
      rating: 5,
      date: '02-18',
      course: '数据科学与AI'
    },
    {
      id: 7,
      username: 'SecurityGeek',
      avatar: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/course/2024/03-03/2304160d2470297968.png',
      content: '网络安全课程内容稍显基础，希望能增加更多高级渗透测试和漏洞分析的内容',
      rating: 3,
      date: '01-25',
      course: '网络安全'
    },
    {
      id: 8,
      username: 'BlockchainDev',
      avatar: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/course/2024/03-03/2304160d2470297968.png',
      content: '区块链课程讲得很透彻，从基础概念到实际应用都有涉及，非常满意！',
      rating: 5,
      date: '03-05',
      course: '区块链技术'
    }
  ];

  // 学习动态数据
  const learningActivities = [
    {
      id: 1,
      username: 'Frank1990',
      avatar: comments[0].avatar,
      activityType: '正在学习',
      courseName: '306降龙十八掌ProMaxPlusUltilmate',
      progress: 88,
      time: '22:08'
    },
    {
      id: 2,
      username: 'Brush1990',
      avatar: comments[0].avatar,
      activityType: '完成学习',
      courseName: '粘性不可压缩流体动量守恒的Navier-Stokes方程...',
      progress: 66,
      time: '21:01'
    },
    {
      id: 3,
      username: 'DX',
      avatar: comments[0].avatar,
      activityType: '加入课程',
      courseName: '《Rust服务器入门到放弃》',
      time: '12:05'
    },
    {
      id: 4,
      username: '官哥用户名的极限长度',
      avatar: comments[0].avatar,
      activityType: '加入班级',
      courseName: '《Unity永久班》',
      time: '09:54'
    },
    {
      id: 5,
      username: 'Python大神',
      avatar: comments[0].avatar,
      activityType: '完成课程',
      courseName: '《Python数据分析与可视化》',
      time: '昨天'
    },
    {
      id: 6,
      username: 'AI_Learner',
      avatar: comments[0].avatar,
      activityType: '提交作业',
      courseName: '《深度学习与神经网络》第三章作业',
      progress: 45,
      time: '昨天'
    },
    {
      id: 7,
      username: 'WebDeveloper',
      avatar: comments[0].avatar,
      activityType: '获得证书',
      courseName: '《全栈Web开发》认证证书',
      time: '前天'
    },
    {
      id: 8,
      username: 'GameArtist',
      avatar: comments[0].avatar,
      activityType: '分享作品',
      courseName: '《游戏美术设计》期末项目',
      progress: 100,
      time: '3天前'
    },
    {
      id: 9,
      username: 'UnityFan',
      avatar: comments[0].avatar,
      activityType: '发表讨论',
      courseName: '《Unity引擎优化》讨论区',
      time: '4天前'
    },
    {
      id: 10,
      username: 'C++学习者',
      avatar: comments[0].avatar,
      activityType: '完成章节',
      courseName: '《C++高级编程》第五章',
      progress: 78,
      time: '5天前'
    }
  ];

  return (
    <section className="course-section">
      <PhoneButton />
      
      <div className="section-header">
        <h2 className="section-title">{title}</h2>
        <p className="section-description">{description}</p>
      </div>
      
      <div className="course-grid">
        {type === 'featured' && (
          <>
            {featuredCourses.map(course => (
              <CourseCard key={course.id} course={course} />
            ))}
            
            <div className="view-all-container">
              <button className="view-all-button glass-effect">
                查看全部
                <svg className="arrow-icon" viewBox="0 0 24 24" width="16" height="16">
                  <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" />
                </svg>
              </button>
            </div>
          </>
        )}
        
        {type === 'unity' && unityCourses.map(course => (
          <UnityCard key={course.id} course={course} />
        ))}
        
        {type === 'comments' && (
          <div className="comments-container">
            <div className="comments-column">
              <h3 className="column-title">学员评价</h3>
              <div className="comment-list scrollable">
                {comments.map(comment => (
                  <CommentCard key={comment.id} comment={comment} />
                ))}
              </div>
            </div>
            <div className="comments-column">
              <h3 className="column-title">学习动态</h3>
              <div className="learning-records scrollable">
                {learningActivities.map(activity => (
                  <div key={activity.id} className="learning-record">
                    <div className="user-avatar">
                      <img src={activity.avatar} alt="用户头像" />
                    </div>
                    <div className="record-content">
                      <div className="record-user">
                        {activity.username} 
                        {activity.progress && (
                          <span className="progress-tag">学习进度 {activity.progress}%</span>
                        )}
                      </div>
                      <div className="record-activity">
                        {activity.activityType} <span className="course-name">{activity.courseName}</span>
                      </div>
                      <div className="record-time">{activity.time}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

export default CourseSection; 